<template>
  <div v-show="isVisible" class="cat-scroll-to-top">
    <cat-btn
      is="button"
      class="cat-scroll-to-top-button"
      :small="true"
      :aria-label="ariaLabel"
      :secondary="true"
      icon="up-circled"
      @ui-click="scrollToTop"
    >
      {{ buttonText }}
    </cat-btn>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";

export default defineComponent({
  name: "CatPageScrollToTop",
  props: {
    buttonText: {
      type: String,
      default: "Scroll to top",
      description: "The text that is displayed in the scroll to top button"
    },
    ariaLabel: {
      type: String,
      default: "Scroll to top of the page",
      description: "The aria label of the scroll to top button"
    },
    distanceFromTop: {
      type: Number,
      default: 300,
      description:
        "The scroll distance in pixels from the top of the page before the scroll to top button becomes visible"
    }
  },
  mounted: function () {
    window.addEventListener("scroll", this.checkScrollPosition);

    this.checkScrollPosition();
  },
  beforeUnmount: function () {
    window.removeEventListener("scroll", this.checkScrollPosition);
  },
  methods: {
    checkScrollPosition() {
      this.isVisible = window.scrollY > this.distanceFromTop;
    },
    scrollToTop() {
      const skipContentButtonLink = document.querySelector(
        ".cat-skip-link"
      ) as HTMLElement;

      if (skipContentButtonLink) {
        skipContentButtonLink.focus();
      }

      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  },
  data: function () {
    return {
      isVisible: false
    };
  }
});
</script>
